import React from "react";
import { Player } from '@lottiefiles/react-lottie-player';

interface Props {
    height? : string;
    animation? : string;
}
const Loading = ({height = '300px', animation = 'https://lottie.host/05f470cd-8fbe-4b4b-b44d-d28c8dd0a7a6/szmPq7vrho.json'} : Props) =>{
    return(
        <Player 
            src={animation}
            background="transparent"
            speed={1}
            style={{width: '200px', height: height}}
            className="ml-auto mr-auto loading" loop autoplay></Player>
    )
}

export default Loading;